import type { Agency } from '@atlas/shared';
import { listAgencies } from './callables.js';

/**
 * Active agencies for the export picker. The list rarely changes within a
 * session and is ~hundreds of rows, so it's fetched once and memoised on the
 * in-flight promise (subsequent callers reuse it). Call `refreshAgencies` to
 * force a re-fetch.
 */
let agenciesPromise: Promise<Agency[]> | null = null;

export function fetchAgencies(): Promise<Agency[]> {
  if (!agenciesPromise) {
    agenciesPromise = listAgencies()
      .then((r) => r.data.agencies)
      .catch((err) => {
        // Reset so a later attempt can retry rather than caching the failure.
        agenciesPromise = null;
        throw err;
      });
  }
  return agenciesPromise;
}

export function refreshAgencies(): Promise<Agency[]> {
  agenciesPromise = null;
  return fetchAgencies();
}
